<template>
  <b-card>
    <h1>Privacy Policy</h1>
    <p>Last Updated: February 27, 2025</p>

    <h2>1. Introduction</h2>
    <p>
      Welcome to PostMate! Your privacy is important to us. This Privacy Policy
      explains how we collect, use, and protect your personal information.
    </p>

    <h2>2. Information We Collect</h2>
    <p>We may collect the following types of information:</p>
    <ul>
      <li>
        Personal Information: Name, email address, etc., if provided
        voluntarily.
      </li>
      <li>
        Usage Data: IP address, browser type, pages visited, and other analytics
        data.
      </li>
      <li>Cookies: We use cookies to enhance user experience.</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <p>We use collected data to:</p>
    <ul>
      <li>Improve our website experience.</li>
      <li>Provide customer support.</li>
      <li>Analyze website performance.</li>
    </ul>

    <h2>4. Third-Party Services</h2>
    <p>
      We may use third-party services such as Google Analytics, which may
      collect information for analytics purposes.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We implement appropriate security measures to protect your data, but we
      cannot guarantee absolute security.
    </p>

    <h2>6. Your Rights</h2>
    <p>
      You have the right to request data deletion or access your collected
      information. Contact us at support@postmate.introvertweb.com.
    </p>

    <h2>7. Changes to This Policy</h2>
    <p>We may update this policy. Please review it periodically for changes.</p>

    <h2>8. Contact Us</h2>
    <p>
      If you have any questions, contact us at
      support@postmate.introvertweb.com.
    </p>
  </b-card>
</template>

<script>
export default {
  metaInfo: {
    title: "Privacy Policy",
    titleTemplate: "%s | Privacy Policy",
  },
};
</script>

<style></style>
